import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  min-height: 100%;
}

:host :where(.th-card, .th-gradient, .th-surface-soft):not(.cursor-pointer):not(button):not(a):not([role=button]) {
  cursor: default;
}`],
})
export class PageHomeComponent implements OnInit {
    public theme: string = 'b';
    public userName: string = '';
    public healthScore: number = 78;
    public healthLabel: string = '양호';
    public todayCoaching: string = '오늘은 가벼운 산책으로 하루를 시작해보세요. 소음인 체질에는 따뜻한 활동이 좋습니다.';
    public constitutionType: string = '소음인';
    public temperatureType: string = '한(寒)';
    public healthConnected: boolean = false;
    public healthLoading: boolean = false;
    public samsungHealthReady: boolean = false;
    public samsungHealthAuthUrl: string = '';

    public healthSummary: any[] = [
        { label: '걸음수', value: '0', unit: '보', progress: 0, icon: 'steps' },
        { label: '수면', value: '0', unit: '시간', progress: 0, icon: 'sleep' },
        { label: '심박수', value: '0', unit: 'bpm', progress: 0, icon: 'heart' }
    ];

    public linkedSources: any[] = [
        { icon: 'medical', label: '건강검진', status: '연동 완료', desc: '최근 검진 수치 1건 반영', link: '/records' },
        { icon: 'watch', label: '스마트헬스', status: '미연동', desc: '삼성 헬스 연동으로 자동 수집', link: '/records' },
        { icon: 'microphone', label: '문진 챗봇', status: '3문항 대기', desc: '누락 생활습관 데이터를 음성으로 보완', link: '/chatbot' }
    ];

    public insightHighlights: any[] = [
        { icon: 'moon', title: '생체 리듬', desc: '수면-활동 리듬 안정도 76%' },
        { icon: 'users', title: '비교 리포트', desc: '동일 연령군 대비 상위 68%' },
        { icon: 'leaf', title: '양생 코칭', desc: '체질 맞춤 생활 가이드 제공' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    private getStorageValue(key: string, fallback: string): string {
        try {
            return localStorage.getItem(key) || fallback;
        } catch {
            return fallback;
        }
    }

    private async renderSafely() {
        try {
            await this.service.render();
        } catch {
        }
    }

    public async ngOnInit() {
        try {
            await this.service.init();
            this.theme = this.getStorageValue('app-theme', 'b');
            await this.load();
            if (!this.healthConnected) {
                await this.loadSamsungHealthSetup();
            }

            const urlParams = new URLSearchParams(window.location.search);
            const samsungResult = urlParams.get('samsung_health');
            if (samsungResult === 'success') {
                this.healthConnected = true;
                history.replaceState({}, '', window.location.pathname);
                await this.loadSamsungHealthData();
            } else if (samsungResult === 'error') {
                history.replaceState({}, '', window.location.pathname);
            }
        } catch {
            this.healthLoading = false;
        } finally {
            await this.renderSafely();
        }
    }

    public async loadSamsungHealthSetup() {
        try {
            let res = await wiz.call('samsung_health_auth_url');
            if (res.code !== 200 || !res.data) {
                throw new Error('samsung_health_auth_url failed');
            }

            this.samsungHealthReady = !!res.data.ready;
            this.samsungHealthAuthUrl = res.data.auth_url || '';
            return;
        } catch {
            this.samsungHealthReady = false;
            this.samsungHealthAuthUrl = '';
        }
    }

    public async load() {
        try {
            let res = await wiz.call("summary");
            if (res.code !== 200 || !res.data) {
                return;
            }

            const data = res.data.data || res.data;
            if (data.name) this.userName = data.name;
            if (data.health_score) this.healthScore = data.health_score;
            if (data.constitution) this.constitutionType = data.constitution;
            this.healthConnected = !!data.samsung_health_connected;

            if (!this.healthConnected) {
                return;
            }

            this.linkedSources[1].status = '자동 수집';
            this.linkedSources[1].desc = '걸음·수면·심박 실시간 동기화';
            await this.loadSamsungHealthData();
        } catch {
            this.healthConnected = false;
        }
    }

    public async loadSamsungHealthData() {
        this.healthLoading = true;
        await this.renderSafely();

        try {
            let res = await wiz.call("samsung_health_data");
            const d = res && res.code === 200 && res.data ? (res.data.data || res.data) : null;
            if (d && d.connected) {

                const steps = Number(d.steps) || 0;
                this.healthSummary[0].value = steps.toLocaleString();
                this.healthSummary[0].progress = Math.min(Math.round(steps / 10000 * 100), 100);

                const sleep = Number(d.sleep_hours) || 0;
                this.healthSummary[1].value = sleep.toFixed(1);
                this.healthSummary[1].progress = Math.min(Math.round(sleep / 8 * 100), 100);

                const hr = Number(d.heart_rate) || 0;
                this.healthSummary[2].value = hr > 0 ? String(hr) : '0';
                this.healthSummary[2].progress = hr > 0 ? Math.min(Math.round(hr / 100 * 100), 100) : 0;
            }
        } catch {
        } finally {
            this.healthLoading = false;
            await this.renderSafely();
        }
    }

    public getVisibleSummary(): any[] {
        if (this.theme === 'c') {
            return this.healthSummary.slice(0, 2);
        }
        return this.healthSummary;
    }

    public goConstitution() {
        this.service.href('/constitution');
    }

    public goAnalysis() {
        this.service.href('/analysis');
    }

    public goRecords() {
        this.service.href('/records');
    }

    public goSource(source: any) {
        this.service.href(source.link);
    }

    public async dismissHealthCard() {
        this.healthConnected = true;
        await this.renderSafely();
    }

    public async goHealthConnect() {
        if (!this.samsungHealthReady || !this.samsungHealthAuthUrl) {
            await this.loadSamsungHealthSetup();
        }

        if (!this.samsungHealthReady || !this.samsungHealthAuthUrl) {
            return;
        }

        location.href = this.samsungHealthAuthUrl;
    }

    public refreshPage() {
        location.reload();
    }
}

export default PageHomeComponent;